import { i18n } from "./_DatabaseModel";
import { mdiFilter } from "@mdi/js";
import Category from "../classes/Category";
import { useAuthUserStore } from "../stores/authUser";

const ASSET_CATEGORIES_TAB_TEMPLATES = 16;
const ASSET_CATEGORIES_TAB_PARENTS = 176;

class AssetCategory extends Category {
  static model = "asset_category";

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { text: "", value: "tags", sortable: false },
  ];

  static createNewObject = {
    ...Category.createNewObject,
    object: { icon: "asset", rm_asset_type: null },
  };

  static basicInfo(object) {
    return [
      {
        labelKey: "category.label.use_in_risk_management",
        value: object.rm_asset_type
          ? i18n.t(`asset.rm_asset_types.${object.rm_asset_type}`)
          : "",
        type: "plain",
      },
      ...Category.basicInfo(object),
    ];
  }

  static submenuActions = [
    {
      icon: mdiFilter,
      titleKey: "asset.assets",
      link: (object) => `/#/assets?category_id=${object.id}`,
      target: "_self",
    },
    ...Category.submenuActions,
  ];

  static tabs = [
    ...Category.tabs,
    {
      titleKey: "category.label.parents",
      permission: ASSET_CATEGORIES_TAB_PARENTS,
      component: "CategoryParentsTab",
      disabled: () => {
        const authUserStore = useAuthUserStore();
        return !["implementer", "admin"].includes(authUserStore.tier);
      },
    },
    {
      titleKey: "template.templates",
      permission: ASSET_CATEGORIES_TAB_TEMPLATES,
      component: "TemplatesAssignmentsTab",
      parameters: { entity_type: "Category" },
      disabled: () => {
        const authUserStore = useAuthUserStore();
        return !["implementer", "admin"].includes(authUserStore.tier);
      },
    },
  ];
}

export default AssetCategory;
